
export const selectMultiStoreList = (state:any) => state.multiStore.multiStoreList;
export const selectMultiStoreLoading = (state:any) => state.multiStore.multiStoreLoading;
export const selectStoreOpenModal = (state:any) => state.multiStore.openStoreModal;
export const selectChangeStoreModal = (state:any) => state.multiStore.openChangeStoreModal;
export const selectOpenStoreModal = (state:any) => state.multiStore.openLocationModal;
export const selectAddEditStoreLoading = (state:any) => state.multiStore.addEditStoreLoading;
export const selectAddEditAddressStoreLoading = (state:any) => state.multiStore.addEditStoreAddressLoading;

